import Pusher, { Channel, ConnectionManager } from "pusher-js";

export interface ISocketService {
  subscribe(channelName: string): Channel;
  unsubscribe(channelName: string): void;
}

interface IPusher extends ISocketService {
  connection: ConnectionManager;
}

export const createSocketService = (uri: string, appKey: string, broadcastToken: string): ISocketService => {
  const socketInstance: IPusher = new Pusher(appKey, {
    cluster: "eu",
    forceTLS: true,
    channelAuthorization: {
      transport: "ajax",
      endpoint: uri,
      headers: {
        "X-CSRF-Token": broadcastToken
      },
      customHandler: (params, callback) => {
        const formData = new URLSearchParams();
        formData.append("socket_id", params.socketId);
        formData.append("channel_name", params.channelName);

        fetch(uri, {
          method: "POST",
          headers: {
            "X-CSRF-Token": broadcastToken
          },
          credentials: "include",
          body: formData
        })
          .then((response) => {
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
          })
          .then((data) => callback(null, data))
          .catch((error) => callback(error, null));
      }
    }
  });

  socketInstance.connection.bind("connected", () => {
    console.log("[Pusher]: connected to a server");
  });

  socketInstance.connection.bind("subscription_error", (error: any) => {
    console.log("[Pusher Subscribe Error] : ", error);
  });

  return {
    subscribe: (channelName: string): Channel => {
      return socketInstance.subscribe(channelName);
    },
    unsubscribe: (channelName: string): void => {
      socketInstance.unsubscribe(channelName);
    }
  };
};
